import { NAME } from './constants';

export const NOTIFY_SIGNUP = `${NAME}/NOTIFY_SIGNUP`;
export const CONFIRM_SIGNUP = `${NAME}/CONFIRM_SIGNUP`;
export const RESEND_VERIFICATION_CODE = `${NAME}/RESEND_VERIFICATION_CODE`;

export const SIGNUP = `${NAME}/SIGNUP`;
export const LOGIN = `${NAME}/LOGIN`;
export const RESET_PASSWORD = `${NAME}/RESET_PASSWORD`;
export const FORGOT_PASSWORD = `${NAME}/FORGOT_PASSWORD`;
